import React, {useEffect} from "react";
import {Col, Row} from "react-bootstrap";
import {RequireAuth} from "Components/Security/RequireAuth";
import {DefaultContainer} from "Views/Shared/DefaultContainer";
import {useNavigate} from "react-router-dom";
import {Notificator} from "Services/Notificator/Notificator";
import {ROUTE_PATHS} from "Config/Router/Routes";
import {useMutation} from "react-query";
import {useAppDispatch} from "hooks";
import {appLoading} from "Store/loadingSlice";
import {AdminBankSwiftCodeForm} from "Views/BankSwiftCodes/AdminBankSwiftCodeForm";
import {createBankSwiftCode} from "Api/Mutation/BankSwiftCodeMutation";

export const AdminBankSwiftCodeCreate: React.FC = () => {

    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const create = useMutation({
        mutationKey: ['createBankSwiftCode'],
        mutationFn: (body: any) => createBankSwiftCode(body),
        onSuccess: () => {
            Notificator.success('El código SWIFT se ha creado correctamente');
            navigate(ROUTE_PATHS.ADMIN_BANK_SWIFT_CODES_LIST);
        },
        onError: () => {
            Notificator.error('Se ha producido un error al crear el código SWIFT');
        }
    });

    useEffect(() => {
        dispatch(appLoading({value: create.isLoading, text: 'Cargando'}));
    }, [create.isLoading]);

    return (
        <RequireAuth>
            <DefaultContainer>
                <Col>
                    <Row>
                        <Col>
                            <h1 className={"pb-4"}>Crear código SWIFT</h1>
                        </Col>
                    </Row>
                    <Row>
                        <AdminBankSwiftCodeForm onSave={(data) => create.mutate(data)}/>
                    </Row>
                </Col>
            </DefaultContainer>
        </RequireAuth>
    );
};
